
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h4 {...{
      "id": "ad-selection-features"
    }}>{`Ad selection features`}</h4>
    <p>{`We’ve extended `}<a parentName="p" {...{
        "href": "/use-cases/job-posting/ad-selection"
      }}>{`ad selection`}</a>{` to indicate when an ad product supports branding and search bullets.`}</p>
    <p>{`This allows you to update your UI to either show or hide your branding and search bullet fields depending on the selected product:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Query the `}<a parentName="p" {...{
            "href": "/use-cases/job-posting/ad-selection/graphql"
          }}>{`graph`}</a>{` for ad product features.`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-scoobie-merged-code",
            "metastring": "[{\"type\":\"code\",\"lang\":\"graphql\",\"meta\":\"lovato-ignore-no-deprecated-schema\",\"value\":\"query seekAnzHirerAdvertisementProducts(\\n  $advertisementId: String!\\n  $hirerId: String!\\n  $draftAdvertisement: SeekAnzAdProductAdvertisementDraftInput!\\n) {\\n  seekAnzHirerAdvertisementCreationProducts(\\n    hirerId: $hirerId\\n    draftAdvertisement: $draftAdvertisement\\n  ) {\\n    ...productFields\\n  }\\n\\n  seekAnzHirerAdvertisementModificationProducts(\\n    hirerId: $hirerId\\n    advertisementId: $advertisementId\\n    draftAdvertisement: $draftAdvertisement\\n  ) {\\n    ...productFields\\n  }\\n}\\n\\nfragment productFields on SeekAnzAdProduct {\\n  name\\n  features {\\n    brandingIndicator\\n    searchBulletPointsIndicator\\n  }\\n}\",\"position\":{\"start\":{\"line\":9,\"column\":3,\"offset\":308},\"end\":{\"line\":38,\"column\":6,\"offset\":1023},\"indent\":[3,3,3,3,3,3,3,3,3,3,3,1,3,3,3,3,3,3,3,3,1,3,3,3,3,3,3,3,3]}},{\"type\":\"code\",\"lang\":\"json\",\"meta\":null,\"value\":\"{\\n  \\\"hirerId\\\": \\\"seekAnzPublicTest:organization:seek:93WyyF1h\\\",\\n  \\\"advertisementId\\\": \\\"seekAnzPublicTest:positionProfile:jobAd:2782PZfXV\\\",\\n  \\\"draftAdvertisement\\\": {\\n    \\\"typeCode\\\": \\\"Classic\\\",\\n    \\\"hirerJobReference\\\": \\\"Job-152\\\",\\n    \\\"positionTitle\\\": \\\"Software Developer\\\",\\n    \\\"jobCategoryId\\\": \\\"seekAnzPublicTest:jobCategory:seek:2EFstqFvP\\\",\\n    \\\"positionLocationId\\\": \\\"seekAnzPublicTest:location:seek:2vArzkyio\\\"\\n  }\\n}\",\"position\":{\"start\":{\"line\":40,\"column\":3,\"offset\":1027},\"end\":{\"line\":52,\"column\":6,\"offset\":1476},\"indent\":[3,3,3,3,3,3,3,3,3,3,3,3]}},{\"type\":\"code\",\"lang\":\"json\",\"meta\":null,\"value\":\"{\\n  \\\"seekAnzHirerAdvertisementCreationProducts\\\": [\\n    {\\n      \\\"name\\\": \\\"Classic\\\",\\n      \\\"features\\\": {\\n        \\\"brandingIndicator\\\": false,\\n        \\\"searchBulletPointsIndicator\\\": false\\n      }\\n    },\\n    {\\n      \\\"name\\\": \\\"StandOut\\\",\\n      \\\"features\\\": {\\n        \\\"brandingIndicator\\\": true,\\n        \\\"searchBulletPointsIndicator\\\": true\\n      }\\n    },\\n    {\\n      \\\"name\\\": \\\"Premium\\\",\\n      \\\"features\\\": {\\n        \\\"brandingIndicator\\\": true,\\n        \\\"searchBulletPointsIndicator\\\": true\\n      }\\n    }\\n  ],\\n  \\\"seekAnzHirerAdvertisementModificationProducts\\\": [\\n    {\\n      \\\"name\\\": \\\"Classic\\\",\\n      \\\"features\\\": {\\n        \\\"brandingIndicator\\\": false,\\n        \\\"searchBulletPointsIndicator\\\": false\\n      }\\n    },\\n    {\\n      \\\"name\\\": \\\"StandOut\\\",\\n      \\\"features\\\": {\\n        \\\"brandingIndicator\\\": true,\\n        \\\"searchBulletPointsIndicator\\\": true\\n      }\\n    },\\n    {\\n      \\\"name\\\": \\\"Premium\\\",\\n      \\\"features\\\": {\\n        \\\"brandingIndicator\\\": true,\\n        \\\"searchBulletPointsIndicator\\\": true\\n      }\\n    }\\n  ]\\n}\",\"position\":{\"start\":{\"line\":54,\"column\":3,\"offset\":1480},\"end\":{\"line\":103,\"column\":6,\"offset\":2578},\"indent\":[3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3]}}]",
            "[{\"type\":\"code\",\"lang\":\"graphql\",\"meta\":\"lovato-ignore-no-deprecated-schema\",\"value\":\"query": true,
            "seekAnzHirerAdvertisementProducts(\\n": true,
            "": true,
            "$advertisementId:": true,
            "String!\\n": true,
            "$hirerId:": true,
            "$draftAdvertisement:": true,
            "SeekAnzAdProductAdvertisementDraftInput!\\n)": true,
            "{\\n": true,
            "seekAnzHirerAdvertisementCreationProducts(\\n": true,
            "hirerId:": true,
            "$hirerId\\n": true,
            "draftAdvertisement:": true,
            "$draftAdvertisement\\n": true,
            ")": true,
            "...productFields\\n": true,
            "}\\n\\n": true,
            "seekAnzHirerAdvertisementModificationProducts(\\n": true,
            "advertisementId:": true,
            "$advertisementId\\n": true,
            "}\\n}\\n\\nfragment": true,
            "productFields": true,
            "on": true,
            "SeekAnzAdProduct": true,
            "name\\n": true,
            "features": true,
            "brandingIndicator\\n": true,
            "searchBulletPointsIndicator\\n": true,
            "}\\n}\",\"position\":{\"start\":{\"line\":9,\"column\":3,\"offset\":308},\"end\":{\"line\":38,\"column\":6,\"offset\":1023},\"indent\":[3,3,3,3,3,3,3,3,3,3,3,1,3,3,3,3,3,3,3,3,1,3,3,3,3,3,3,3,3]}},{\"type\":\"code\",\"lang\":\"json\",\"meta\":null,\"value\":\"{\\n": true,
            "\\\"hirerId\\\":": true,
            "\\\"seekAnzPublicTest:organization:seek:93WyyF1h\\\",\\n": true,
            "\\\"advertisementId\\\":": true,
            "\\\"seekAnzPublicTest:positionProfile:jobAd:2782PZfXV\\\",\\n": true,
            "\\\"draftAdvertisement\\\":": true,
            "\\\"typeCode\\\":": true,
            "\\\"Classic\\\",\\n": true,
            "\\\"hirerJobReference\\\":": true,
            "\\\"Job-152\\\",\\n": true,
            "\\\"positionTitle\\\":": true,
            "\\\"Software": true,
            "Developer\\\",\\n": true,
            "\\\"jobCategoryId\\\":": true,
            "\\\"seekAnzPublicTest:jobCategory:seek:2EFstqFvP\\\",\\n": true,
            "\\\"positionLocationId\\\":": true,
            "\\\"seekAnzPublicTest:location:seek:2vArzkyio\\\"\\n": true,
            "}\\n}\",\"position\":{\"start\":{\"line\":40,\"column\":3,\"offset\":1027},\"end\":{\"line\":52,\"column\":6,\"offset\":1476},\"indent\":[3,3,3,3,3,3,3,3,3,3,3,3]}},{\"type\":\"code\",\"lang\":\"json\",\"meta\":null,\"value\":\"{\\n": true,
            "\\\"seekAnzHirerAdvertisementCreationProducts\\\":": true,
            "[\\n": true,
            "\\\"name\\\":": true,
            "\\\"features\\\":": true,
            "\\\"brandingIndicator\\\":": true,
            "false,\\n": true,
            "\\\"searchBulletPointsIndicator\\\":": true,
            "false\\n": true,
            "}\\n": true,
            "},\\n": true,
            "\\\"StandOut\\\",\\n": true,
            "true,\\n": true,
            "true\\n": true,
            "\\\"Premium\\\",\\n": true,
            "],\\n": true,
            "\\\"seekAnzHirerAdvertisementModificationProducts\\\":": true,
            "]\\n}\",\"position\":{\"start\":{\"line\":54,\"column\":3,\"offset\":1480},\"end\":{\"line\":103,\"column\":6,\"offset\":2578},\"indent\":[3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3]}}]": true
          }}>{`query seekAnzHirerAdvertisementProducts(
  $advertisementId: String!
  $hirerId: String!
  $draftAdvertisement: SeekAnzAdProductAdvertisementDraftInput!
) {
  seekAnzHirerAdvertisementCreationProducts(
    hirerId: $hirerId
    draftAdvertisement: $draftAdvertisement
  ) {
    ...productFields
  }

  seekAnzHirerAdvertisementModificationProducts(
    hirerId: $hirerId
    advertisementId: $advertisementId
    draftAdvertisement: $draftAdvertisement
  ) {
    ...productFields
  }
}

fragment productFields on SeekAnzAdProduct {
  name
  features {
    brandingIndicator
    searchBulletPointsIndicator
  }
}
`}</code></pre>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Get the features in the `}<inlineCode parentName="p">{`onChange`}</inlineCode>{` event raised by the `}<a parentName="p" {...{
            "href": "/use-cases/job-posting/ad-selection/panel"
          }}>{`Ad Selection Panel`}</a>{`.`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-javascript"
          }}>{`SEEKAdPostingWidget.render(document.getElementById('seekWidget1ContainerDiv'), {
  mode: 'Create',
  onChange: function (event) {
    const { advertisement } = event;
    const { features } = advertisement;
    const { brandingIndicator, searchBulletPointsIndicator } = features;

    console.log(\`Branding \${brandingIndicator : 'is' : 'is not'} supported\`);
    console.log(\`Search bullet points \${searchBulletPointsIndicator : 'are' : 'are not'} supported\`);

    if (brandingIndicator) {
      // show field to select a brand
    } else {
      // hide brand field
    }
    if (searchBulletPointsIndicator) {
      // show fields to enter bullet points
    } else {
      // hide bullet point fields
    }
  },
  getAuthToken: function () {
    return Promise.resolve('browser token');
  },
  draftAdvertisement: {
    positionTitle: 'Developer',
    jobCategoryId: 'seekAnzPublicTest:jobCategory:seek:2EFstqFvP',
    positionLocationId: 'seekAnzPublicTest:location:seek:2TCFhBtw9',
    hirerJobReference: 'Premium521',
  },
});
`}</code></pre>
      </li>
    </ul>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;